import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { format } from 'date-fns';
import { AlertController, ModalController } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { PlatformService } from 'src/app/platform.service';
import { BamboraCheckoutPage } from '../../modals/bambora-checkout/bambora-checkout.page';
import { MonerisCheckoutPage } from '../../modals/moneris-checkout/moneris-checkout.page'
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.page.html',
  styleUrls: ['./add-payment.page.scss'],
})
export class AddPaymentPage implements OnInit {
  buttons = []
  errors=[]
  width = window.innerWidth;
  yearOptions ={
    header: 'Year',
    subHeader: 'Select expiry year',
    translucent: true,
  }
  monthOptions = {
    header: 'Month',
    subHeader: 'Select expiry month',
    translucent: true,
  };
  minDate: any = format(new Date(), 'yyyy');
  expiryDates=[]
  loaded=false
  paymentForm:FormGroup= new FormGroup({})
  @Input() paymentType: any;
  constructor(
    private alertController:AlertController,
    private errorHandlerSRV:ErrorHandlerService,
    private toastSRV: ToastService,
    private platformSRV:PlatformService,
    private iab: InAppBrowser,
    private toasterSRV:ToastService,
    private loaderSRV:LoaderService,
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private dataService: DataService,
    public translateService: TranslateService,
    private http: HttpClient,
    private router:Router,
  ) { }

  async ngOnInit() {
    
    
    for(var i=0;i<15;i++){
      this.expiryDates.push(parseFloat(this.minDate)+i)
    }
   
   
      if(this.paymentType['promptFor'].toLowerCase()=="creditcard"){
        this.paymentForm = this.fb.group({
          "cardType": this.paymentType['PaymentTypeID'],
          "label" : "",
          "cardName":"",
          "cardNumber":"",
          "cardExpiryMonth":"",
          "cardExpiryYear":"",
          "cardCVVD":""
          
        })
        this.loaded=true
      } else if(this.paymentType['gateway'].toString().toLowerCase().includes('hostpay')){
        
        this.paymentForm = this.fb.group({
          "cardType": this.paymentType['PaymentTypeID'],
          "label" : " ",
          "cardName":" ",
          "cardNumber":" ",
          "cardExpiryMonth":" ",
          "cardExpiryYear":" ",
          "cardCVVD":" ",
          "redirect_url": this.dataService.apiUrl + '/www/'
        })
        this.dataService.postData('account/subscriptions/creditcard/add',this.paymentForm.value).subscribe({
          next: async (res) => {
        
            var  url=
              res['redirect'] 
             //to detect if user manually closed the in app browser
             var closedAutomatically=false
             
             
              if(this.platformSRV.isNative.value){
                const browser = this.iab.create(url,'_blank',this.dataService.browserOptionsOptions)
                var connectedToUrlDetails = new URL(this.dataService.apiUrl)
                browser.on('exit').subscribe(data=>{
                  if(closedAutomatically){
                    this.loaded=true
                    this.modalCtrl.dismiss('reload')
                  } else {
                    this.modalCtrl.dismiss()
                  }
                  
                })
                browser.on('loadstart').subscribe(browserResult=>{
                  var urlDetails = new URL(browserResult.url)
                  if(connectedToUrlDetails.hostname == urlDetails.hostname){
                    closedAutomatically=true
                    browser.close()
                   
                  }
                })
              } else {
                window.location.href = url;

              }
             this.loaded=true
              
          },
          error: async (err) =>{
            this.toastSRV.presentErrorToast('an error occured, try again later')
            this.modalCtrl.dismiss()
          }
        })
          
          
        
      } else if(this.paymentType['gateway'].toString() == 'BamboraCheckout'){
        this.dataService.getData('api/v1/user/bambora/'+this.paymentType['PaymentTypeID']+'/payment_profile').subscribe({
          next:async (response:any)=>{
            var editProfile=false
            var editAddress=false
            var message=''
           for (var i = 0; i < Object.entries(response?.errors).length; i++) {
           message+=Object.entries(response?.errors)[i][1][0]
           if(Object.entries(response?.errors)[i][0] =='phone_number'){
            editProfile=true
           }
           if(Object.entries(response?.errors)[i][0] =='address_line1' || Object.entries(response?.errors)[i][0] =='city' || Object.entries(response?.errors)[i][0] =='postal_code'){
            editAddress=true
           }
            if(i!=Object.entries(response?.errors).length-1){
              message+='<br>'
            }
          }
          
            if(!response?.has_profile){
              if(editProfile){
                this.buttons.push( {
                  text: (this.translateService.instant('keys.data.profile.edit_profile') || 'Edit Profile'),
                  handler:(async ()=>{
                    this.modalCtrl.dismiss('dismiss')
                    this.router.navigateByUrl('/account/profile')
                  }) 
                })
              } if(editAddress){
                this.buttons.push( {
                  text:  (this.translateService.instant('keys.data.profile.edit_address') || 'Edit Address'),
                  handler:(async ()=>{
                    this.modalCtrl.dismiss('dismiss')
                    this.router.navigateByUrl('/account/addresses')
                  }) 
                })
              }
             
              this.buttons.push({
                text: 'cancel',
                role: 'cancel',
                handler:(async ()=>{
                 this.modalCtrl.dismiss('dismiss')
                }) 
              })
              
              const alert=await this.alertController.create({
                message: message,
                buttons: this.buttons
              })
              await alert.present()
            } else {
              this.paymentForm = this.fb.group({
                "cardType": this.paymentType['PaymentTypeID'],
                "label" : " ",
                "cardName":" ",
                "cardNumber":" ",
                "cardExpiryMonth":" ",
                "cardExpiryYear":" ",
                "cardCVVD":" "
              })
              this.dataService.postData('account/subscriptions/creditcard/add',this.paymentForm.value).subscribe({
               
                next:async (res:any)=>{
                 
                
                const desktopModal = await this.modalCtrl.create({
                  component: BamboraCheckoutPage,
                  breakpoints: [0.5, 0.8,1],
                  initialBreakpoint: 1,
                  cssClass: 'modal-desktop-wide',
                  componentProps:{
                  res,
                  from:"subscriptions",
                  paymentType:this.paymentType
                }
                });
                const mobileModal = await this.modalCtrl.create({
                  component: BamboraCheckoutPage,
                  breakpoints: [0.5, 0.8,1],
                  initialBreakpoint: 1,
                  cssClass:"modal-mobile-normal",
                  componentProps:{
                  res,
                  from:"subscriptions",
                  paymentType:this.paymentType
                }
                })
                const tabletModal = await this.modalCtrl.create({
                  component: BamboraCheckoutPage,
                  breakpoints: [0.5, 0.8,1],
                  initialBreakpoint: 1, 
                  cssClass:"modal-tablet-normal",
                  componentProps:{
                  res,
                  from:"subscriptions",
                  paymentType:this.paymentType
                }
                })
                mobileModal.onDidDismiss().then(response=>{
                  if(response.data=='reload'){
                    this.modalCtrl.dismiss("reload")
                  } else {
                    this.modalCtrl.dismiss("dismiss")
                  }
                  
                })
                desktopModal.onDidDismiss().then(response=>{
                 if(response.data=='reload'){
                    this.modalCtrl.dismiss("reload")
                  } else {
                    this.modalCtrl.dismiss("dismiss")
                  }
                })
                tabletModal.onDidDismiss().then(response=>{
                 if(response.data=='reload'){
                    this.modalCtrl.dismiss("reload")
                  } else {
                    this.modalCtrl.dismiss("dismiss")
                  }
                })
                if(this.platformSRV.device=='desktop'){
                  return await desktopModal.present();
                } else if(this.platformSRV.device=='mobile'){
                  return await mobileModal.present();
                } else if(this.platformSRV.device=='tablet'){
                  return await tabletModal.present();
                }
             
              
              this.loaded=true
                  
                  
                },
                error:err=>{
                  this.modalCtrl.dismiss()
                  this.errorHandlerSRV.displayErrorMessage(err,true)
                }
                
             
              
              }
              
              )
            }
            
          }
          ,error:err=>{
            this.errorHandlerSRV.displayErrorMessage(err,true)
          }
        })
        
        
      }
      // else if(this.paymentType['gateway'].toString() == 'MonerisCheckout'){
      //   this.paymentForm = this.fb.group({
      //     "cardType":this.paymentType['PaymentTypeID'],
      //     "label" : " ",
      //     "cardName":" ",
      //     "cardNumber":" ",
      //     "cardExpiryMonth":" ",
      //     "cardExpiryYear":" ",
      //     "cardCVVD":" "
      //   })
      //   this.dataService.postData('account/subscriptions/creditcard/add',this.paymentForm.value).subscribe(async res=>{
         
          
      //     this.modalCtrl.dismiss()
      //     const desktopModal = await this.modalCtrl.create({
      //       component: MonerisCheckoutPage,
      //       breakpoints: [0.5, 0.8,1],
      //       initialBreakpoint: 1,
      //       cssClass: 'modal-desktop-wide',
      //        componentProps:{
      //       res,
      //       from:"subscriptions"
      //     }
      //     });
      //     const mobileModal = await this.modalCtrl.create({
      //       component: MonerisCheckoutPage,
      //       breakpoints: [0.5, 0.8,1],
      //       initialBreakpoint: 1,
      //       cssClass:"modal-mobile-normal",
      //        componentProps:{
      //       res,
      //       from:"subscriptions"
      //     }
      //     })
      //     const tabletModal = await this.modalCtrl.create({
      //       component: MonerisCheckoutPage,
      //       breakpoints: [0.5, 0.8,1],
      //       initialBreakpoint: 1, 
      //       cssClass:"modal-tablet-normal",
      //        componentProps:{
      //       res,
      //       from:"subscriptions"
      //     }
      //     })
      //     mobileModal.onDidDismiss().then(response=>{
      //       this.modalCtrl.dismiss("dismiss")
      //     })
      //     desktopModal.onDidDismiss().then(response=>{
      //       this.modalCtrl.dismiss("dismiss")
      //     })
      //     tabletModal.onDidDismiss().then(response=>{
      //       this.modalCtrl.dismiss("dismiss")
      //     })
      //     if(this.platformSRV.device=='desktop'){
      //       return await desktopModal.present();
      //     } else if(this.platformSRV.device=='mobile'){
      //       return await mobileModal.present();
      //     } else if(this.platformSRV.device=='tablet'){
      //       return await tabletModal.present();
      //     }
        
       
        
      //   this.loaded=true
        
      //   })
      // } 
      else if(this.paymentType['gateway'].toString().toLowerCase()=='monerischeckout'){
       this.loaded=true
        
      }
    
    
    
  }
  postPaymentMethod(){
    this.errors=[]
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.payments.adding_payment_method') || 'Adding payment method...')
    this.dataService.postData('account/subscriptions/creditcard/add',this.paymentForm.value).subscribe({
      next:(res:any)=>{
        if(res?.status=='success'){
          this.loaderSRV.dismissLoader()
          this.modalCtrl.dismiss('reload')
          if(res?.message){
            this.modalCtrl.dismiss()
            this.loaderSRV.dismissLoader()
            this.toasterSRV.presentToast(res['message'])
          }
        } else {
          this.modalCtrl.dismiss()
          this.errorHandlerSRV.displayErrorMessage(res,true)
        }
        
      },
      error:err=>{
        
       this.errorHandlerSRV.displayErrorMessage(err,false).then(res=>{
        this.errors=res.fields
       })
       
        this.loaderSRV.dismissLoader()
       
      }
      
    })
  }
  closeModal() {
  
    this.modalCtrl.dismiss('reload')
    
  }

}
